<cache-date></cache-date>

<period></period>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<br>

<loading [isLoad]="chartLoader"></loading>
<div class="row">
	<div class="col-md-12">
		<chart [data]="chart.data" [options]="chart.options" [sextant]="'chart'"></chart>
	</div>
</div>
